// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_3gxmE","Title":"Hero__Title_2hr0S","Grid":"Hero__Grid_1sB0T","Factoids":"Hero__Factoids_1rEpt"};